import React from "react";
import { Link } from "react-router-dom";
import { useCustomerAddresses } from "../../hooks/useCustomerAddresses";
import Footer from "../../components/Footer";

const AddressesPage = () => {
  const { addresses, loading, error, refetchAddresses } =
    useCustomerAddresses();

  const handleDeleteAddress = (addressId) => {
    console.log("Silinecek Adres ID:", addressId);
    alert("Adres silme fonksiyonu henüz implemente edilmedi.");
    // TODO: addressService.deleteAddress(addressId) çağrısı
    // TODO: Başarılı olursa refetchAddresses() çağrısı
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="flex-grow max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 w-full">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
            Adreslerim
          </h1>
          <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="-ml-1 mr-2 h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
            Yeni Adres Ekle
          </button>
        </div>

        {loading && (
          <p className="text-center text-gray-500 py-10">
            Adresler yükleniyor...
          </p>
        )}
        {error && (
          <div className="text-center text-red-500 py-10">
            <p>Hata: {error}</p>
            <button
              onClick={refetchAddresses}
              className="mt-4 px-4 py-2 border border-red-300 text-red-600 rounded hover:bg-red-50"
            >
              Tekrar Dene
            </button>
          </div>
        )}

        {!loading && !error && addresses.length === 0 && (
          <p className="text-center text-gray-500 py-10">
            Kayıtlı adresiniz bulunmamaktadır.
          </p>
        )}

        {!loading && !error && addresses.length > 0 && (
          <div className="bg-white shadow overflow-hidden sm:rounded-md">
            <ul role="list" className="divide-y divide-gray-200">
              {addresses.map((address) => (
                <li key={address.id}>
                  <div className="px-4 py-4 sm:px-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <div className="flex items-center flex-1 min-w-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-gray-400 mr-3 flex-shrink-0"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                      <div className="min-w-0 flex-1">
                        <p className="text-sm font-medium text-indigo-600 truncate">
                          {address.title || "Adres Başlığı Yok"}
                        </p>
                        <p className="mt-1 flex items-center text-sm text-gray-500">
                          <span className="truncate">
                            {address.address || "Adres detayı yok"}
                          </span>
                        </p>
                        <p className="mt-1 text-sm text-gray-500">
                          <span className="font-medium">
                            {address.district_name || "İlçe Yok"} /{" "}
                            {address.city_name || "Şehir Yok"}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="mt-2 sm:mt-0 flex items-center space-x-3 flex-shrink-0">
                      <button
                        type="button"
                        className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="-ml-0.5 mr-1.5 h-4 w-4 text-gray-400"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                          />
                        </svg>
                        Düzenle
                      </button>
                      <button
                        type="button"
                        onClick={() => handleDeleteAddress(address.id)}
                        className="inline-flex items-center px-3 py-1.5 border border-transparent shadow-sm text-xs font-medium rounded text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="-ml-0.5 mr-1.5 h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          />
                        </svg>
                        Sil
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default AddressesPage;
